<div #table class="table-container">
    <form [formGroup]="form" class="form-container" *ngIf="isEdit && form" (ngSubmit)="onSubmit()">
        <!-- <table [ngClass]="{'no-data-table': keysBody.objects | search: search : searchKey).length === 0}"> -->
        <table [ngClass]="{'no-data-table': keysBody?.objects.length === 0 && newItems?.length === 0}">
            <thead>
                <!-- <tr [ngClass]="{'center-header': (keysBody.objects | search: search : searchKey).length === 0}"> -->
                <tr [ngClass]="{'center-header': keysBody?.objects.length === 0 && newItems?.length === 0}">
                    <ng-container *ngFor="let keyColumn of keysColumn; let index = index">
                        <th *ngIf="keyColumn.data !== null" [ngClass]="getTHClass(index, keyColumn)">
                            {{ keyColumn.title }}
                        </th>
                    </ng-container>
                    <th class="table-button-header set-width" *ngIf="tableButtonNewItem">
                        <button type="button" (click)="addNewItem(idSource)">
                            <div #newItem class="button-header"></div>
                        </button>
                    </th>
                    <th class="table-button-header set-width" *ngIf="deleteDuringEdit">
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="!loading && isEdit && keysBody?.objects">
                <tr *ngFor="let keyBody of keysBody?.objects | paginate: { id: id ,itemsPerPage: keysBody?.perpage === -1 ? null : keysBody?.perpage, currentPage: keysBody?.page, totalItems: keysBody?.total }"
                    (click)="onClickRowActive(keyBody)" [ngClass]="{ 'clickable-row': isRowsClickable }">
                    <td *ngFor="let keyColumn of filterData(keysColumn); let index = index"
                        [ngClass]="{'larger-form': keysColumn[index].mustBeLarge}">
                        <div *ngIf="!keyColumn.isEditable"> {{formatData(keyBody[keyColumn.data], keyColumn)}}
                        </div>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'string' && keyColumn.isEditable" type="text"
                            [formGroup]="form" [control]="form.get(keyBody.id+keyColumn.data)"
                            [id]="keyBody.id+keyColumn.data" (modelChanged)="addToChangeLog(keyBody)"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'textarea' && keyColumn.isEditable" type="textarea"
                            [formGroup]="form" [control]="form.get(keyBody.id+keyColumn.data)"
                            [id]="keyBody.id+keyColumn.data" (modelChanged)="addToChangeLog(keyBody)"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>


                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'date' && keyColumn.isEditable" type="date" [formGroup]="form"
                            [control]="form.get(keyBody.id+keyColumn.data)" (modelChanged)="addToChangeLog(keyBody)"
                            [id]="keyBody.id+keyColumn.data" [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'number' && keyColumn.isEditable" type="number"
                            [formGroup]="form" [control]="form.get(keyBody.id+keyColumn.data)"
                            [id]="keyBody.id+keyColumn.data" (modelChanged)="addToChangeLog(keyBody)"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'select' && keyColumn.isEditable" type="text"
                            [formGroup]="form" [control]="form.get(keyBody.id+keyColumn.data)"
                            [id]="keyBody.id+keyColumn.data" (modelChanged)="addToChangeLog(keyBody)"
                            [errorMessage]="keyColumn.errorMessage" required="true" [selectValue]="keyColumn.editValue">
                        </frg-form-input>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'ngSelect' && keyColumn.isEditable" type="ngSelect"
                            [formGroup]="form" [control]="form.get(keyBody.id+keyColumn.data)"
                            (modelChanged)="addToChangeLog(keyBody)" [errorMessage]="keyColumn.errorMessage"
                            [isClearableSelect]="keyColumn.isClearableSelect === false ? false : true" required="true"
                            [selectValue]="keyColumn.editValue" [id]="keyBody.id+keyColumn.data">
                        </frg-form-input>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'multiple' && keyColumn.isEditable" type="ngSelect"
                            [closeOnSelect]="false" [formGroup]="form" [control]="form.get(keyBody.id+keyColumn.data)"
                            [isMultiSelect]="true" (modelChanged)="addToChangeLog(keyBody)"
                            [isClearableSelect]="keyColumn.isClearableSelect === false ? false : true"
                            [errorMessage]="keyColumn.errorMessage" required="true" [selectValue]="keyColumn.editValue"
                            [id]="keyBody.id+keyColumn.data">
                        </frg-form-input>

                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'ref-search-input' && keyColumn.isEditable"
                            type="ref-search-input" [formGroup]="form" [control]="form.get(keyBody.id+keyColumn.data)"
                            [id]="keyBody.id+keyColumn.data" (modelChanged)="addToChangeLog(keyBody)"
                            [refSearchInput]="keyBody.refSearchInput" [autorizedRefs]="keyColumn.autorizedRefs"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>

                        <label *ngIf="keyColumn.editType === 'boolean' && keyColumn.isEditable">
                            <input id="actif" [formGroup]="form" [formControlName]="keyBody.id+keyColumn.data"
                                [id]="keyBody.id+keyColumn.data" (ngModelChange)="addToChangeLog(keyBody)"
                                type="checkbox">
                            <span class="checkMark"></span>
                        </label>
                    </td>
                    <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                        class="table-button-container center-item" *ngIf="tableButton1 && deleteDuringEdit">
                        <button type="button" (click)="onClick1Active(keyBody)"
                            [ngClass]="{ 'block-delete': keyBody.cantDelete }"
                            [title]="keyBody.buttonTitle ? keyBody.buttonTitle : ''">
                            <!-- <div #button1 name="button1" [ngStyle]="{'background-image': getButton1Icon()}"
                                class="table-button delete"></div> -->

                            <frg-inline-svg #button1 name="button1" class="table-button delete"
                                [src]="getButton1Icon(keyBody.button1Icon)"
                                [title]="getTooltip(tableButton1Tooltip, keyBody.button1Title)"
                                [fill]="(keyBody.active1 ? keyBody.active1 : undefined)"></frg-inline-svg>
                        </button>
                    </td>
                    <td class="table-button-container" *ngIf="tableButtonNewItem && deleteDuringEdit">
                        <!-- Besoin de cette cellule pour un affichage propre lorsque le bouton de création est présent dans le header du tableau -->
                    </td>
                </tr>
                <tr *ngFor="let item of newItems">
                    <td *ngFor="let keyColumn of filterData(keysColumn); let index = index"
                        [ngClass]="{'larger-form': keysColumn[index].mustBeLarge}">
                        <div *ngIf="!keyColumn.editType"> {{formatData(item[keyColumn.data], keyColumn)}}
                        </div>
                        <frg-form-input class="input-margin" *ngIf="keyColumn.editType === 'textarea'" type="textarea"
                            [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [id]="item.id+keyColumn.data" (modelChanged)="addToChangeLog(item)"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>
                        <frg-form-input class="input-margin" *ngIf="keyColumn.editType === 'string'" type="text"
                            [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [id]="item.id+keyColumn.data" (modelChanged)="addToChangeLog(item)"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>
                        <frg-form-input class="input-margin" *ngIf="keyColumn.editType === 'date'" type="date"
                            [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [id]="item.id+keyColumn.data" (modelChanged)="addToChangeLog(item)"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>
                        <frg-form-input class="input-margin" *ngIf="keyColumn.editType === 'number'" type="number"
                            [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [id]="item.id+keyColumn.data" (modelChanged)="addToChangeLog(item)"
                            [errorMessage]="keyColumn.errorMessage" required="true">
                        </frg-form-input>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'ngSelect' && keyColumn.isEditable" type="ngSelect"
                            [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [isClearableSelect]="keyColumn.isClearableSelect === false ? false : true"
                            (modelChanged)="addToChangeLog(item)" [errorMessage]="keyColumn.errorMessage"
                            required="true" [selectValue]="keyColumn.editValue" [id]="item.id+keyColumn.data">
                        </frg-form-input>
                        <frg-form-input class="input-margin" *ngIf="keyColumn.editType === 'select'" type="text"
                            [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [id]="item.id+keyColumn.data" (modelChanged)="addToChangeLog(item)"
                            [errorMessage]="keyColumn.errorMessage" required="true" [selectValue]="keyColumn.editValue">
                        </frg-form-input>
                        <label *ngIf="keyColumn.editType === 'boolean'">
                            <input id="actif" [formGroup]="form" [formControlName]="item.id+keyColumn.data"
                                (ngModelChange)="addToChangeLog(item)" type="checkbox">
                            <span class="checkMark"></span>
                        </label>
                        <frg-form-input class="input-margin"
                            *ngIf="keyColumn.editType === 'multiple' && keyColumn.isEditable" type="ngSelect"
                            [closeOnSelect]="false" [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [isMultiSelect]="true" (modelChanged)="addToChangeLog(item)"
                            [isClearableSelect]="keyColumn.isClearableSelect === false ? false : true"
                            [errorMessage]="keyColumn.errorMessage" required="true" [selectValue]="keyColumn.editValue"
                            [id]="item.id+keyColumn.data">
                        </frg-form-input>

                        <frg-form-input class="input-margin" *ngIf="keyColumn.editType === 'ref-search-input'"
                            type="ref-search-input" [formGroup]="form" [control]="form.get(item.id+keyColumn.data)"
                            [id]="item.id+keyColumn.data" (modelChanged)="addToChangeLog(item)"
                            [refSearchInput]="item.id+keyColumn.refSearchInput"
                            [autorizedRefs]="keyColumn.autorizedRefs" [errorMessage]="keyColumn.errorMessage"
                            required="true">
                        </frg-form-input>
                    </td>
                    <td class="table-button-container" *ngIf="tableButtonNewItem && !deleteDuringEdit">
                        <div class="table-button"></div>
                        <!-- Besoin de cette cellule pour un affichage propre lorsque le bouton de création est présent dans le header du tableau -->
                    </td>
                </tr>
            </tbody>
            <div class="no-data" *ngIf="!loading && keysBody?.objects.length === 0 && newItems?.length === 0">
                <p>Aucune information à afficher</p>
            </div>
        </table>
        <div class='no-data' *ngIf="loading">
            <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <div class="buttons-container" *ngIf="showFormButton">
            <frg-button backgroundColor="var(--darkest-primary)" *ngIf="isEdit" type="button"
                (click)="toggleEditMode()">Annuler l'édition
            </frg-button>
            <frg-button type="submit">Valider l'édition</frg-button>
        </div>
    </form>

    <!-- gestion du header de la table contenant les titres des colonnes dans "thead" -->

    <!-- <table *ngIf="!edit" [ngClass]="{'no-data-table': (keysBody.objects | search: search : searchKey).length === 0}"> -->
    <table *ngIf="!isEdit" [ngClass]="{'no-data-table': keysBody?.objects.length === 0}">
        <thead>
            <!-- <tr [ngClass]="{'center-header': (keysBody.objects | search: search : searchKey).length === 0}"> -->
            <tr [ngClass]="{'center-header': keysBody?.objects.length === 0}">
                <th *ngFor="let keyColumn of keysColumn; let index = index" (click)="sort(keyColumn)"
                    [ngClass]="getTHClass(index, keyColumn)"
                    [ngStyle]="{'width':keyColumn.styleWidth ? keyColumn.styleWidth : 'auto'}">
                    {{ keyColumn.title }}
                    <span *ngIf="keyColumn.data === sortBy" class="arrow"
                        [ngClass]="{'arrow-up': sortOrder === 'DESC', 'arrow-down': sortOrder === 'ASC'}">
                    </span>
                </th>
                <th class="table-button-header set-width" *ngIf="tableButtonHeader">
                    <button type="button" (click)="onClickButtonHeader()">
                        <div #buttonHeader class="button-header"></div>
                    </button>
                </th>
            </tr>
        </thead>

        <!-- affichage du contenu des colonnes dans "tbody" -->

        <tbody cdkDropList (cdkDropListDropped)="dropped($event)" [id]="idDropTable"
            [cdkDropListConnectedTo]="idConnectedTable" *ngIf="!loading && keysBody?.objects.length > 0 && dragDrop">
            <!-- <tr
                *ngFor="let keyBody of keysBody.objects | search: search : searchKey | paginate: { itemsPerPage: keysBody.perpage, currentPage: keysBody.page, totalItems: keysBody.total }"> -->
            <tr cdkDrag
                *ngFor="let keyBody of keysBody?.objects | paginate: { id: id, itemsPerPage: keysBody?.perpage === -1 ? null : keysBody?.perpage, currentPage: keysBody?.page, totalItems: keysBody?.total }"
                (click)="onClickRowActive(keyBody)" [ngClass]="{ 'clickable-row': isRowsClickable }">
                <td [ngClass]="{'disabled': keyBody?.actif === false}" *ngFor="let keyColumn of filterData(keysColumn)"
                    [ngStyle]="{'background-color': keyColumn.isCellColor && keyBody[keyColumn.data] ? hexToRgba('#'+keyBody[keyColumn.data]) : keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : '','color': keyBody.textColor ? hexToRgba('#'+keyBody.textColor, 1) : ''}">
                    <span
                        *ngIf="!keyColumn.editType || keyColumn.editType !== 'boolean'">{{formatData(keyBody[keyColumn.data],
                        keyColumn)}}</span>
                    <span *ngIf="keyColumn.editType && keyColumn.editType === 'boolean'"
                        style="filter: opacity(0.5);pointer-events: none;">
                        <label>
                            <input type="checkbox" id="actif" [checked]="keyBody[keyColumn.data]">
                            <span class="checkMark"></span>
                        </label>
                    </span>
                    <span *cdkDragPreview>
                      <!-- {{formatData(keyBody[keyColumn.data],keyColumn)}} -->
                        <ng-container *ngIf="formatData(keyBody[keyColumn.data], keyColumn); else emptyPreview">
                          {{ formatData(keyBody[keyColumn.data], keyColumn) }}
                        </ng-container>
                        <ng-template #emptyPreview>
                          <!-- Ici, ton fallback -->
                          <span style="display: inline-block; width: 6rem; height: 3rem; background: var(--primary);box-shadow: 0px 7px 10px -6px var(--box-shadow-grey); border: 1px solid var(--darkest-primary); border-radius: 0.3rem;">
                          </span>
                        </ng-template>
                    </span>
                    <span *cdkDragPlaceholder>{{formatData(keyBody[keyColumn.data],
                        keyColumn)}}</span>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container center-item" *ngIf="tableButton1">
                    <button type="button" (click)="onClick1Active(keyBody)"
                        [ngClass]="{ 'block-delete': keyBody.cantDelete }"
                        [title]="keyBody.buttonTitle ? keyBody.buttonTitle : ''">
                        <!-- <div #button1 name="button1" [ngStyle]="{'background-image': getButton1Icon()}"
                            class="table-button delete"></div> -->
                        <frg-inline-svg #button1 name="button1" class="table-button delete"
                            [src]="getButton1Icon(keyBody.button1Icon)"
                            [title]="getTooltip(tableButton1Tooltip, keyBody.button1Title)"
                            [fill]="(keyBody.active1 ? keyBody.active1 : undefined)"></frg-inline-svg>
                    </button>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container center-item" *ngIf="tableButton2">
                    <button type="button" (click)="onClick2Active(keyBody)"
                        [ngClass]="{ 'block-delete': keyBody.cantEdit }"
                        [title]="keyBody.buttonTitle ? keyBody.buttonTitle : ''">
                        <!-- <div #button2 name="button2" [ngStyle]="{'background-image': getButton2Icon()}"
                            class="table-button edit"></div> -->
                        <frg-inline-svg #button2 name="button2" class="table-button edit"
                            [src]="getButton2Icon(keyBody.button2Icon)"
                            [title]="getTooltip(tableButton2Tooltip, keyBody.button2Title)"
                            [fill]="(keyBody.active2 ? keyBody.active2 : undefined)"></frg-inline-svg>
                    </button>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container center-item" *ngIf="tableButton3">
                    <button type="button" (click)="onClick3Active(keyBody)"
                        [ngClass]="{ 'block-delete': keyBody.cantEdit }"
                        [title]="keyBody.buttonTitle ? keyBody.buttonTitle : ''">
                        <frg-inline-svg #button3 name="button3" class="table-button edit" [src]="getButton3Icon(keyBody.button3Icon)" [title]="getTooltip(tableButton3Tooltip, keyBody.button3Title)"
                            [fill]="(keyBody.active3 ? keyBody.active3 : undefinded)"></frg-inline-svg>
                    </button>
                </td>

                <td class="table-button-container" *ngIf="tableButtonHeader">
                    <!-- Besoin de cette cellule pour un affichage propre lorsque le bouton de création est présent dans le header du tableau -->
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="!loading && keysBody?.objects.length > 0 && !dragDrop">
            <!-- <tr
                *ngFor="let keyBody of keysBody.objects | search: search : searchKey | paginate: { itemsPerPage: keysBody.perpage, currentPage: keysBody.page, totalItems: keysBody.total }"> -->
            <!-- [ngClass]="{'disabledRow': keyBody.cantDelete != null}" -->
            <tr *ngFor="let keyBody of keysBody?.objects | paginate: { id: id, itemsPerPage: keysBody?.perpage === -1 ? null : keysBody?.perpage, currentPage: keysBody?.page, totalItems: keysBody?.total }"
                (click)="onClickRowActive(keyBody)" [ngClass]="{ 'clickable-row': isRowsClickable }">
                <td [ngClass]="{'disabled': keyBody?.actif === false}" *ngFor="let keyColumn of filterData(keysColumn)"
                    [ngStyle]="{'background-color': keyColumn.isCellColor && keyBody[keyColumn.data] ? hexToRgba('#'+keyBody[keyColumn.data]) : keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : '','color': keyBody.textColor ? hexToRgba('#'+keyBody.textColor, 1) : (keyColumn.textColor ? keyColumn.textColor : '')}">
                    <span
                        *ngIf="!keyColumn.editType || keyColumn.editType !== 'boolean'">{{formatData(keyBody[keyColumn.data],
                        keyColumn)}}</span>
                    <span *ngIf="keyColumn.editType && keyColumn.editType === 'boolean'"
                        style="filter: opacity(0.5);pointer-events: none;">
                        <label>
                            <input type="checkbox" id="actif" [checked]="keyBody[keyColumn.data]">
                            <span class="checkMark"></span>
                        </label>
                    </span>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container center-item" *ngIf="tableButton1">
                    <button type="button" (click)="onClick1Active(keyBody)"
                        [ngClass]="{ 'block-delete': keyBody.cantDelete }"
                        [title]="keyBody.buttonTitle ? keyBody.buttonTitle : ''">
                        <!-- <div #button1 name="button1" [ngStyle]="{'background-image': getButton1Icon()}"
                            class="table-button delete"></div> -->
                        <frg-inline-svg #button1 name="button1" class="table-button delete"
                            [src]="getButton1Icon(keyBody.button1Icon)"
                            [title]="getTooltip(tableButton1Tooltip, keyBody.button1Title)"
                            [fill]="(keyBody.active1 ? keyBody.active1 : undefined)"></frg-inline-svg>
                    </button>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container center-item" *ngIf="tableButton2">
                    <button type="button" (click)="onClick2Active(keyBody)"
                        [ngClass]="{ 'block-delete': keyBody.cantEdit }"
                        [title]="keyBody.buttonTitle ? keyBody.buttonTitle : ''">
                        <!-- <div #button2 name="button2" [ngStyle]="{'background-image': getButton2Icon()}"
                            class="table-button edit"></div> -->
                        <frg-inline-svg #button2 name="button2" class="table-button edit"
                            [src]="getButton2Icon(keyBody.button2Icon)"
                            [title]="getTooltip(tableButton2Tooltip, keyBody.button2Title)"
                            [fill]="(keyBody.active2 ? keyBody.active2 : undefined)"></frg-inline-svg>
                    </button>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container center-item" *ngIf="tableButton3">
                    <button type="button" (click)="onClick3Active(keyBody)"
                        [ngClass]="{ 'block-delete': keyBody.cantEdit }"
                        [title]="keyBody.buttonTitle ? keyBody.buttonTitle : ''">
                        <frg-inline-svg #button3 name="button3" class="table-button edit"
                            [src]="getButton3Icon(keyBody.button3Icon)"
                            [title]="getTooltip(tableButton3Tooltip, keyBody.button3Title)"
                            [fill]="(keyBody.active3 ? keyBody.active3 : undefined)"></frg-inline-svg>
                    </button>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container" *ngIf="tableButton4">
                    <div class="menu-links">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon><frg-inline-svg #button4 name="button4" class="table-button"
                                    [src]="getButton4Icon(keyBody.button4Icon)"
                                    [title]="getTooltip(tableButton4Tooltip, keyBody.button4Title)"
                                    [fill]="(keyBody.active4 ? keyBody.active4 : undefined)"></frg-inline-svg></mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngFor="let item of dropdownItems; let i = index"
                                (click)="item.registeredFunction(keyBody)">
                                <span>{{ item.title }}</span>
                            </button>
                        </mat-menu>
                    </div>
                </td>
                <td [ngClass]="{'disabled': keyBody.actif != null && keyBody.actif === false}"
                    [ngStyle]="{'background-color': keyBody.rowColor ? hexToRgba('#'+keyBody.rowColor) : ''}"
                    class="table-button-container " *ngIf="tableButton5">

                    <button mat-raised-button [matTooltip]="currentTooltip" [matTooltipClass]="'tooltip-version'"
                        aria-label="Button that displays a tooltip when focused or hovered over"
                        (mouseenter)="onHover5Active(keyBody)">
                        <mat-icon><frg-inline-svg #button5 name="button5" class="table-button"
                                [src]="getButton5Icon(keyBody.button5Icon)"
                                [title]="getTooltip(tableButton5Tooltip, keyBody.button5Title)"
                                [fill]="(keyBody.active5 ? keyBody.active5 : undefined)"></frg-inline-svg></mat-icon>
                    </button>
                </td>
                <td class="table-button-container" *ngIf="tableButtonHeader">
                    <!-- Besoin de cette cellule pour un affichage propre lorsque le bouton de création est présent dans le header du tableau -->
                </td>
            </tr>
        </tbody>

        <div class="no-data" *ngIf="!loading && keysBody?.objects.length === 0 && !dragDrop">
            <p>Aucune information à afficher</p>
        </div>
        <div class="no-data" cdkDropList (cdkDropListDropped)="dropped($event)" [id]="idDropTable"
            [cdkDropListConnectedTo]="idConnectedTable" *ngIf="!loading && keysBody?.objects.length === 0 && dragDrop">
            <p>Aucune information à afficher</p>
        </div>
        <!--  <div class="no-data"
            *ngIf="!loading && (keysBody.objects | search: search : searchKey).length === 0 && keysBody.objects.length !== 0"> -->
        <div class="no-data" *ngIf="!loading && keysBody?.objects.length === 0 && keysBody?.objects.length !== 0">
            <p>Le résultat de votre recherche ne correspond à aucune donnée </p>
        </div>
    </table>
    <div class='no-data' *ngIf="loading">
        <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
<!-- <div class=" table-pagination"
    [ngClass]="{'hidden':(!keysBody.objects || keysBody.total <= keysBody.perpage) || (keysBody.objects | search: search : searchKey).length === 0 || edit}"> -->
<div class=" table-pagination"
    *ngIf="!((!keysBody?.objects || keysBody?.total <= keysBody?.perpage || keysBody?.perpage === -1) || keysBody?.objects.length === 0 || isEdit)">
    <pagination-controls [id]="id" previousLabel="" nextLabel="" (pageChange)="onChangedPage($event)">
    </pagination-controls>
</div>
